module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/vertical/atheroma/pink_minus-4e97ffec4e0f1a19bb486b6821ee9b09.png";